<template>
  <div class="login-page">
    <div class="container-fluid">
      <div class="row justify-content-center">
        <div class="col-lg-8 pb-xl-5 mb-5">
          <div class="text-center">
            <img src="@/assets/imgs/main-logo.svg" class="img-fluid" />
            <div class="form-main-title mt-xl-3">
              <h1>The journey to your dream university starts here!</h1>
            </div>
          </div>
        </div>
        <div class="col-lg-5">
          <div>
            <div class="phone-grid justify-content-center pb-4">
              <div class="">
                <b-dropdown variant="default" class="form-dropdown">
                  <template slot="button-content">
                    <div class="dropdown-content">IN +(91)</div>
                  </template>
                  <b-dropdown-item v-for="(data, index) in 10" :key="index"
                    >IN +(91)</b-dropdown-item
                  >
                </b-dropdown>
              </div>
              <div>
                <input
                  type="text"
                  class="form-input-control form-control"
                  placeholder="Enter your phone number"
                />
              </div>
            </div>

            <div>
              <button class="btn btn-primary btn-common-1 btn-block">Get OTP</button>
            </div>
            <div class="or-text my-xl-5 my-3">
              <span>Or</span>
            </div>
            <div>
              <button class="btn btn-secondary-border btn-block">
                Continue with email
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Login",
  data() {
    return {};
  },
};
</script>



// WEBPACK FOOTER //
// src/components/pages/Login.vue